















import { defineComponent } from '@nuxtjs/composition-api'
import { EMAILS, SITE_NAME } from '~/common/constants/contact'

export default defineComponent({
  setup() {
    return {
      EMAILS,
      SITE_NAME,
    }
  },
})
